module.exports = __webpack_public_path__ + "img/anuncio3.fca651b7.jpg";